export default "__VITE_PUBLIC_ASSET__9268a97f__"